import Router from 'next/router'
import {
  compose,
  withHandlers,
  branch,
  lifecycle,
  renderComponent,
  pure,
  withProps,
  withStateHandlers
} from 'recompose'
import { reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import _get from 'lodash/get'

import { withInitialData } from '../components/hoc'
import { logIn } from '../reducers/user'
import {
  Login,
  AlreadyAuthorized
} from '../components/Login'

const mapStateToProps = state => {
  return {
    loading: state.user.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logIn: credentials => dispatch(logIn(credentials))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    title: 'common:navigation_menu-login',
    contentImage: ''
  }),
  withInitialData,
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.isAuthenticated) {
        Router.push('/')
      }
    }
  }),
  withStateHandlers({
    isSubmitDisabled: false
  },
  {
    setSubmitDisabled: () => (value = false) => ({
      isSubmitDisabled: value
    })
  }),
  withHandlers({
    _handleSubmit: props => data => {
      return props.logIn(data)
        .then(userInfo => {
          if (!userInfo.hasRemoteSessions) {
            props.createNotification({
              type: 'success',
              message: `${props.t('welcome')}, ${userInfo.username}`
            })

            const cartItems = _get(props, 'cart.items')
            if (cartItems && cartItems.length) {
              Router.push('/cart')
            } else {
              Router.push('/')
            }
          }
        })
        .catch(err => {
          const errorData = _get(err, 'response.data', {})
          const formError = _get(err, 'response.data.message') ?
            props.t(_get(err, 'response.data.message')) : props.t('common:server-error')

          if (errorData.code && errorData.code === 'LEGACY_USER_FORCE_RESET') {
            props.setSubmitDisabled(true)
          }

          throw new SubmissionError({
            _error: formError
          })
        })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    form: 'login'
  }),
  branch(props => props.isAuthenticated, renderComponent(AlreadyAuthorized)),
  pure
)(Login)



// WEBPACK FOOTER //
// ./pages/login.js